<template>
<div id="app">
<div>
 <p style="text-align: justify;">
    A verification security code has been sent to your email account.
    Please provide security code that has just been sent to your email account
    to verify and complete your process.
    This includes a time sensitive code.
    If you don’t receive an email, please check your spam folder or contact <b>ASCA Storage Tanks</b> at
    <span style="font-weight: 500;">1-888-413-0099</span>,#2 for ASCA then #2 for ASCA Storage Tanks or by email at <a href= "mailto:ascatanks@safetycodes.ab.ca">ascatanks@safetycodes.ab.ca</a>. 
 </p>
 </div>
 <div>
<div class="e-card">
      <div class="e-card-title">Security Code Verification</div>
      <div class="e-card-separator"></div>
      <div class="e-card-content">
        <div>
          <span class="error-container">
            {{ erorrMessage }}
          </span>
        </div>
        <form class="login" @submit.prevent="verifySecurityCode">
          <scc-input-validator
            :rules="[requiredRule]"
            :value="this.securityCode"
            @validate="(v) => (this.isSecurityCodeValid = v)">
            <ejs-textbox
              float-label-type="Always"
              placeholder="Enter Security Code"
              v-model="securityCode" />
          </scc-input-validator>
          <div class="align-bottom">
            <ejs-button type="submit" cssClass="e-info margin-button">
              Verify Code
            </ejs-button>
          </div>
        </form>
      </div>
    </div>
 </div>
</div>
</template>
<script>

import SccInputValidator from '@/components/base/scc-input-validator.vue';
import { VALIDATE_SECURITY_CODE } from '../store';

export default {
  name: 'SecurityCodeVerification',
  components: {
    SccInputValidator,
  },
  created() {
    // this.token = this.$route.query.temptoken;
    // this.isValidToken(this.token);
    // this.$emit('isSecurityCodeSuccess', this.isSecurityCodeSuccess);
  },
  mounted() {
  },
  data() {
    return {
      securityCode: null,
      erorrMessage: null,
      isSecurityCodeValid: false,
      codeVerificationEventArgs: { isSuccess: false, code: null },
      requiredRule: {
        regEx: '^(?!\\s*$).+',
        message: 'This field is required',
      },
    };
  },
  computed: {
  },
  methods: {
    async verifySecurityCode() {
      try {
        const { securityCode } = this;
        if (this.isSecurityCodeValid) {
          await this.$store.dispatch(VALIDATE_SECURITY_CODE, { securityCode });
          if (this.$store.getters.securityCodeResponse.status === 200) {
            this.$parent.$parent.notificationToasts.push({
              title: 'Success!',
              content: 'A security code has been successfully verified.',
              cssClass: 'e-toast-success',
              timeOut: 5000,
            });
            this.codeVerificationEventArgs.isSuccess = true;
            this.codeVerificationEventArgs.code = securityCode;

            this.$emit('isSecurityCodeSuccess', this.codeVerificationEventArgs);
          } else if (this.$store.getters.securityCodeResponse) {
            switch (this.$store.getters.securityCodeResponse) {
              case 403:
                // this.$router.push('/unauth');
                this.erorrMessage = 'Your session has expired! Please contact ASCA Storage Tanks at 1-888-413-0099, #2 for ASCA then #2 for ASCA Storage Tanks to validate your email address or log into your account again and re-try';
                break;
              case 404:
                // this.$router.push('/unauth');
                this.erorrMessage = 'Invalid token! Please double check your email, or click "Try Again" and re-try';
                break;
              case 423:
                this.erorrMessage = 'Your account is locked. Please contact ASCA Storage Tanks to un-lock your account at 1-888-413-0099, #2 for ASCA then #2 for ASCA Storage Tanks or by email at ascatanks@safetycodes.ab.ca.';
                break;
              default:
                this.erorrMessage = 'Oops, Something went wrong. We are working on getting this fixed as soon as we can. You may be able to try again shortly. If you continue to experience this issue, you can contact ASCA Storage Tanks at 1-888-413-0099, #2 for ASCA then #2 for ASCA Storage Tanks or by email at ascatanks@safetycodes.ab.ca';
            }
            if (this.erorrMessage) {
              this.$parent.$parent.notificationToasts.push({
                title: 'Error!',
                content: this.erorrMessage,
                cssClass: 'e-toast-danger',
                timeOut: 5000,
              });
            }
            this.codeVerificationEventArgs.isSuccess = false;
            this.$emit('isSecurityCodeSuccess', this.codeVerificationEventArgs);
          }
        } else {
          this.securityCode = this.securityCode === null ? '' : this.securityCode;
        }
      } catch (err) {
        console.log('code', err);
        switch (err.status) {
          case 403:
            // this.$router.push('/unauth');
            this.erorrMessage = 'Your session has expired! Please contact Safety Codes Council at 1-888-413-0099 to validate your email address or log into your account again and re-try';
            break;
          case 404:
            // this.$router.push('/unauth');
            this.erorrMessage = 'Invalid token! Please double check your email, or click "Try Again" and re-try';
            break;
          case 423:
            this.erorrMessage = 'Your account is locked. Please contact ASCA Storage Tanks to un-lock your account at 1-888-413-0099, #2 for ASCA then #2 for ASCA Storage Tanks or by email at ascatanks@safetycodes.ab.ca.';
            break;
          default:
            this.erorrMessage = 'Oops, Something went wrong. We are working on getting this fixed as soon as we can. You may be able to try again shortly. If you continue to experience this issue, you can contact ASCA Storage Tanks at 1-888-413-0099, #2 for ASCA then #2 for ASCA Storage Tanks or by email at ascatanks@safetycodes.ab.ca.';
        }
        if (this.erorrMessage) {
          this.$parent.$parent.notificationToasts.push({
            title: 'Error!',
            content: this.erorrMessage,
            cssClass: 'e-toast-danger',
            timeOut: 5000,
          });
        }
      }
      if (this.$parent.$parent.notificationToasts.length > 0) {
        this.$parent.$parent.$refs.notifierRef.show();
      }
    },
  },
};
</script>
<style>
.container {
  padding: 16px 25% 16px 25%;
}
</style>
